/* eslint-disable import/prefer-default-export */
export const DEFAULT_OGP_IMAGE = '/img/ogp.png';
